<template>
    <div class="d-flex flex-column flex-sm-row justify-content-between align-items-center align-items-sm-end w-100 nav-container">
        <router-link to="/" class="order-1 order-sm-0 mt-4 mt-sm-0">
<!--          <img src="../../assets/media/logo/logo.svg" class="logo mr-4" alt="logo" />-->
          <img src="../../assets/media/logo/SFT_samsung-02.png" class="logo mr-4" alt="logo" />
        </router-link>
        <ul class="nav-menu" v-if="menu && menu.items.length > 0">
            <menu-item v-for="(m,i) in root_menu" :key="i" :link="getUrl(m)" :title="m.title" :submenu="getSubMenu(m.ID)"/>
        </ul>
    </div>
</template>

<script>
    import MenuItem from "./MenuItem";
    export default {
        name: "NavMenu",
        components: {MenuItem},
        computed: {
            menu() {
                return this.$store.getters.menu('topbar')
            },
            root_menu() {
                return this.menu.items.filter(m => m.menu_item_parent == 0)
            }
        },
        methods: {
            getSubMenu(id) {
                let sm = this.menu.items.filter(m => m.menu_item_parent == id)
                return sm;
            },
            getUrl(item) {
                return item.url.replace(/^.*\/\/[^/]+/, '')
            }
        }
    }
</script>

<style scoped lang="scss">
    .nav-container {
      background: white;
      padding: 1rem;
      border-radius: 1.5rem;
    }
    .nav-menu{
        align-self: center;
        display: flex;
        flex-direction: column;
        list-style-type: none;
        gap: 32px;
        //width: 100%;
        margin: 0;

        @include media-breakpoint-up(lg){
            flex-direction: row;
            width: initial;
        }
      .register-form-menu-item {
        background-color: $primary;
        border-radius: 40px;
        padding-top: 10px;
        padding-bottom: 10px;
        color: $white;
        text-decoration: none;
      }
    }
</style>
